import { MedicalItem, MedicalItemModel } from "../Models/MedicalSummary/MedicalItem";
import { MedicalItemVitalSign } from "../Models/MedicalSummary/MedicalItemVitalSign";

export class MedicalItemHelper {
    public static getMedicalItemFromVisibleAndValidTemplate(medicalItems: MedicalItem[]): MedicalItem[] {
        const arraySorted: MedicalItem[] = [];
        const groupedItems = medicalItems
            ?.filter(p => p.EMRTemplateIsVisibleInCPP && !p.EMRTemplateIsInvalid)
            ?.groupBy(p => p.EMRTemplateId) ?? [];

        groupedItems.forEach(p => {
            arraySorted.push(MedicalItemModel.sortByCreationDateDesc(p).firstOrDefault() as MedicalItem);
        });

        return arraySorted;
    }

    /**
     * Get the latest valid vital sign
     * @param vitalSigns list of vitals sign
     * @returns the latest valid vital sign
     */
    public static getLatestVitalSign(vitalSigns: Immutable.List<MedicalItemVitalSign>): MedicalItemVitalSign {
        if (!vitalSigns)
            return;

        const newvitalSigns = vitalSigns.toArray()
            .filter(x => x.EMRTemplateIsVisibleInCPP === true && x.EMRTemplateIsInvalid === false)
            .sortByPropertyDesc(x => MedicalItemModel.getVitalSignEffectiveDate(x));

        const latestByEffectiveDate = newvitalSigns.firstOrDefault();
        const sameDatesAsLatestEffectiveDate = newvitalSigns.filter(x => MedicalItemModel.getVitalSignEffectiveDate(x) === MedicalItemModel.getVitalSignEffectiveDate(latestByEffectiveDate));
        return (MedicalItemModel.sortByCreationDateDesc(sameDatesAsLatestEffectiveDate).firstOrDefault());
    }
}
